import React from "react";
import {BrowserRouter, Navigate, Route, Routes as Switch} from "react-router-dom";

import {PrivateRoute} from "../components/Routing";

import Layout from "../components/Layout";
import NotFound from "../pages/NotFound/NotFound";
import Auth from '../pages/Auth'
import Register from "../pages/Register";
import Main from "../pages/Main/index";
import Users from "../pages/Users";
import Sites from "../pages/Sites";
import Position from "../pages/Position";

export default function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path='/auth' element={<Auth />}/>
                <Route path='/register' element={<Register />}/>
                <Route element={<PrivateRoute />}>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Main />}/>
                        <Route path="users" element={<Users />}/>
                        <Route path="sites" element={<Sites />}/>
                        <Route path="pos" element={<Position />}/>
                        <Route path="/notFound" element={<NotFound />}/>
                    </Route>
                </Route>
                <Route path="*" element={<Navigate to = '/notFound' replace />}/>
            </Switch>
        </BrowserRouter>
    );
}